import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInstall = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 8.75,
		cy: 9.25,
		r: 8.25,
		fill: "#5A7481"
	}), /* @__PURE__ */ _jsx("path", {
		className: "no-override",
		d: "M7.50833 11.7417L5.01667 9.25L7.50833 6.75833L6.75 6L3.5 9.25L6.75 12.5L7.50833 11.7417ZM10.325 11.7417L12.8167 9.25L10.325 6.75833L11.0833 6L14.3333 9.25L11.0833 12.5L10.325 11.7417Z",
		fill: "#FBFBFB"
	})]
});
export default SvgInstall;
